// Scales the whole app on desktop so it keeps the same proportions on every
// display scale (Windows 100% / 120% / 150%, Mac Retina, iPad landscape).
//
// The page is laid out as if the browser were DESIGN_WIDTH CSS px wide:
// zoom = viewport width / DESIGN_WIDTH, clamped. A 1920px screen at 150%
// (1280 CSS px) gets 0.8; the same screen at 120% (1600 CSS px) gets 1.0,
// so both look identical. Below DESKTOP_MIN (phones, portrait tablets) the
// zoom stays 1. `--vh` in index.css compensates viewport units for the zoom.

const DESIGN_WIDTH = 1600;
const DESKTOP_MIN = 1024;
const MIN_ZOOM = 0.75;
const MAX_ZOOM = 1;

const computeZoom = (width) => {
  if (width < DESKTOP_MIN) return 1;
  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, width / DESIGN_WIDTH));
};

const applyZoom = () => {
  const root = document.documentElement;
  // Pages can opt out by putting `no-app-zoom` on <html>
  const zoom = root.classList.contains("no-app-zoom") ? 1 : computeZoom(window.innerWidth);
  root.style.setProperty("--app-zoom", String(zoom));
};

export const initAppZoom = () => {
  applyZoom();
  // innerWidth is not affected by CSS zoom, so resizing can't feed back into itself
  window.addEventListener("resize", applyZoom);
  window.addEventListener("orientationchange", applyZoom);
};
